export default {
  state: {
    language: localStorage.getItem('language') || 'zh',
    metaInfo: {
      title: '',
      keywords: '',
      description: ''
    }
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
      localStorage.setItem('language', language)
    },
    CHANGE_META_INFO(state, metaInfo) {
      state.metaInfo = { ...state.metaInfo, ...(metaInfo || {}) }
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setMetaInfo({ commit }, metaInfo) {
      commit('CHANGE_META_INFO', metaInfo)

      if (typeof document !== 'undefined') {
        if (metaInfo && metaInfo.title !== undefined) {
          document.title = metaInfo.title || ''
        }
        const ensureMeta = (name) => {
          let el = document.querySelector(`meta[name="${name}"]`)
          if (!el) {
            el = document.createElement('meta')
            el.setAttribute('name', name)
            document.head.appendChild(el)
          }
          return el
        }
        if (metaInfo && metaInfo.keywords !== undefined) {
          ensureMeta('keywords').setAttribute('content', metaInfo.keywords || '')
        }
        if (metaInfo && metaInfo.description !== undefined) {
          ensureMeta('description').setAttribute('content', metaInfo.description || '')
        }
      }
    }
  }
}